import React, { useEffect, useMemo, useState } from "react";
import { inject, observer } from "mobx-react";
import moment from "moment";

import InfiniteScroll from "react-infinite-scroll-component";

import { makeStyles } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";

import { cx } from "./lib/utils";
import { shimmerStyles } from "./styles";

const useStyles = makeStyles({
  ...shimmerStyles,
  loadingTitle: {
    marginTop: 6,
    borderRadius: "6px",
    height: "16px",
    width: "100%",
  },
  loadingShimmer: {
    borderRadius: "6px",
    height: "14px",
    width: "80%",
    marginBottom: 6,
  },
  loadingShimmer2: {
    borderRadius: "6px",
    height: "14px",
    width: "90%",
    marginBottom: 6,
  },
  loadingDate: {
    marginTop: 6,
    borderRadius: "6px",
    height: "14px",
    width: "30%",
    marginBottom: 16,
  },
  chatHistoryContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  chatHistoryContent: {
    padding: "0.5rem 1rem",

    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflowY: "auto",

    "&::-webkit-scrollbar": {
      width: "10px",
    },

    "&::-webkit-scrollbar-track": {
      display: "none",
    },

    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "transparent",
      borderRadius: "4px",
    },

    "&:hover": {
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "lightgrey",
      },
    },
  },
  secondaryText: {
    paddingTop: "0.75rem",
  },
});

const ChatHistory = (props) => {
  const { chatStore, onChatItemClick } = props;

  const classes = useStyles();

  const [loading, setLoading] = useState(true);

  const handleOnLoad = async (firstLoad = true) => {
    try {
      setLoading(true);
      await chatStore.loadChatsHistory(firstLoad);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const handleNext = async () => {
    await handleOnLoad(false);
  };

  const handleItemClick = (item, index) => (e) => {
    // return null;
    e.stopPropagation();
    e.preventDefault();
    onChatItemClick(item, index, e);
  };

  const loadingShimmer = useMemo(
    () => (
      <div>
        <div className={cx(classes.shimmer, classes.loadingTitle)} />
        <div className={cx(classes.shimmer, classes.loadingShimmer)} />
        <div className={cx(classes.shimmer, classes.loadingShimmer2)} />
        <div className={cx(classes.shimmer, classes.loadingDate)} />
      </div>
    ),
    []
  );

  const renderChatHistoryContent = () => {
    return (
      <InfiniteScroll
        hasMore
        dataLength={chatStore.chatHistory?.length || 0}
        next={handleNext}
        scrollableTarget="scrollableDivChatHistory"
        loader={loading ? loadingShimmer : null}
      >
        {chatStore.chatHistory?.map((history, i) => {
          return (
            <React.Fragment key={i}>
              <ListItem button onClick={handleItemClick(history, i)}>
                <ListItemText
                  primary={history.initial_query}
                  secondary={moment(history.createdAt).format(
                    "MMMM Do YYYY, h:mm:ss a"
                  )}
                  classes={{
                    secondary: classes.secondaryText,
                  }}
                />
              </ListItem>
              <Divider />
            </React.Fragment>
          );
        })}
      </InfiniteScroll>
    );
  };
  const renderChatHistory = () => {
    return (
      <div id="scrollableDivChatHistory" className={classes.chatHistoryContent}>
        {renderChatHistoryContent()}
      </div>
    );
  };

  useEffect(() => {
    handleOnLoad();
  }, []);

  return renderChatHistory();
};

export default inject(({ store }) => {
  return {
    chatStore: store.chatStore,
  };
})(observer(ChatHistory));
